import { apiClient } from "services/api-client"

// Áreas
export const getAreas = async (companyKey) => {
    return await apiClient.get(`/mapping/area?companyKey=${companyKey}`)
}

export const getAreaById = async (id) => {
    return await apiClient.get(`/mapping/area/${id}`)
}

export const addArea = async (data) => {
    return await apiClient.post('/mapping/area', data)
}

export const editArea = async (id, data) => {
    return await apiClient.put(`/mapping/area/${id}`, data)
}

export const deleteArea = async (id) => {
    return await apiClient.delete(`/mapping/area/${id}`)
}

// Dados
export const getDatas = async (companyKey) => {
    return await apiClient.get(`/mapping/data?companyKey=${companyKey}`)
}

export const getDataById = async (id) => {
    return await apiClient.get(`/mapping/data/${id}`)
}

export const addData = async (data) => {
    return await apiClient.post('/mapping/data', data)
}

export const editData = async (id, data) => {
    return await apiClient.put(`/mapping/data/${id}`, data)
}

export const deleteData = async (id) => {
    return await apiClient.delete(`/mapping/data/${id}`)
}

// Assets
export const getAssets = async (companyKey) => {
    return await apiClient.get(`/mapping/asset?companyKey=${companyKey}`)
}

export const getAssetById = async (id) => {
    return await apiClient.get(`/mapping/asset/${id}`)
}

export const addAsset = async (data) => {
    return await apiClient.post('/mapping/asset', data)
}

export const editAsset = async (id, data) => {
    return await apiClient.put(`/mapping/asset/${id}`, data)
}

export const deleteAsset = async (id) => {
    return await apiClient.delete(`/mapping/asset/${id}`)
}

// Processos
export const getProcesses = async (companyKey) => {
    return await apiClient.get(`/mapping/process?companyKey=${companyKey}`)
}

export const getProcessById = async (id) => {
    return await apiClient.get(`/mapping/process/${id}`)
}

export const addProcess = async (data) => {
    return await apiClient.post('/mapping/process', data)
}

export const editProcess = async (id, data) => {
    return await apiClient.put(`/mapping/process/${id}`, data)
}

export const deleteProcess = async (id) => {
    return await apiClient.delete(`/mapping/process/${id}`)
}

// Sistemas
export const getSystems = async (companyKey) => {
    return await apiClient.get(`/mapping/system?companyKey=${companyKey}`)
}

export const getSystemById = async (id) => {
    return await apiClient.get(`/mapping/system/${id}`)
}

export const addSystem = async (data) => {
    return await apiClient.post('/mapping/system', data)
}

export const editSystem = async (id, data) => {
    return await apiClient.put(`/mapping/system/${id}`, data)
}

export const deleteSystem = async (id) => {
    return await apiClient.delete(`/mapping/system/${id}`)
}

// Relatórios ROPA
export const getReportRopa = async (companyKey) => {
    return await apiClient.get(`/mapping/report-ropa?companyKey=${companyKey}`)
}

export const generateReportRopa = async (data) => {
    return await apiClient.post('/mapping/report-ropa', data)
}

// Bases Legais
export const getLegalBases = async (companyKey) => {
    return await apiClient.get(`/mapping/legal-bases?companyKey=${companyKey}`)
}

// Categorias de Dados
export const getDataCategories = async (companyKey) => {
    return await apiClient.get(`/mapping/data-categories?companyKey=${companyKey}`)
}

// Health Check
export const healthCheck = async () => {
    return await apiClient.get('/healthcheck')
}